import { AxiosError } from 'axios'

export default function isAxiosError(payload: unknown): payload is AxiosError {
  return (payload as AxiosError).isAxiosError === true
}
